import React from 'react';

const CorbeilleSvg = ({width = 20, height = 20, couleur = "#F82121"}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.30907 16.1505L2.71824 4.33398H17.2824L16.6916 16.1505C16.6118 17.7471 15.294 19.0007 13.6953 19.0007H6.30532C4.7067 19.0007 3.3889 17.7471 3.30907 16.1505Z"
            stroke={couleur} strokeWidth="2"/>
        <path
            d="M6.83301 4H13.1663V3C13.1663 1.89543 12.2709 1 11.1663 1H8.83301C7.72844 1 6.83301 1.89543 6.83301 3V4Z"
            stroke={couleur} strokeWidth="2"/>
        <path d="M0.833008 4.16602H19.1663" stroke={couleur} strokeWidth="2"/>
        <path d="M12.5 9.16602V13.3327" stroke={couleur} strokeWidth="2"/>
        <path d="M7.5 9.16602V13.3327" stroke={couleur} strokeWidth="2"/>
    </svg>
);

export default CorbeilleSvg;
